import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import nodejs from "../assets/img/skills/node.webp"
import react from "../assets/img/skills/react.png"
import laravel from "../assets/img/skills/laravel.svg"
import mysql from "../assets/img/skills/mysql.webp"
import javascript from "../assets/img/skills/javascript.svg"
import redis from "../assets/img/skills/redis.svg"
import mongo from "../assets/img/skills/mongo.svg"
import graphql from "../assets/img/skills/graphql.svg"
import tailwind from "../assets/img/skills/tailwind.svg"
import next from "../assets/img/skills/next.svg"
import colorSharp from "../assets/img/color-sharp.png"

const skillsData = [
  {
    title: 'Back End',
    items: [
      { image: nodejs, label: 'Nodejs/ExpressJs' },
      { image: laravel, label: 'PHP/Laravel' },
      { image: mongo, label: 'MongoDB' },
      { image: mysql, label: 'Mysql' },
      { image: redis, label: 'Redis' },
      { image: graphql, label: 'Rest Api/Graphql' },
    
    ],
  },
  {
    title: 'Front End',
    items: [
      { image: javascript, label: 'Html/Css/Javascript' },
      { image: react, label: 'ReactJs' },
      { image: tailwind, label: 'Tailwindcss' },
      { image: react, label: 'React Native' },
      { image: next, label: 'NextJs' },
    ],
  },
];

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2 className="mb-2" >Skills</h2>
                        
                        {skillsData.map((section) => (
                          
                          <div key={section.title}>
                              <hr className="px-4 mx-4" />
                            <h3 style={{margin :"20px 0"}}>{section.title}</h3>
                            <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                              {section.items.map((skill) => (
                                <div className="item" key={`${section.title}-${skill.label}`}>
                                  <img src={skill.image} alt="Image" />
                                  <h5>{skill.label}</h5>
                                </div>
                              ))}
                            
                            </Carousel>
                          
                          </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
   
    </section>
  )
}
